@file:OptIn(InternalResourceApi::class)

package dev.wyns.ventrova.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/dev.wyns.ventrova.resources/"

@delegate:ResourceContentHash(878_485_388)
internal val Res.drawable.ic_add: DrawableResource by lazy {
      DrawableResource("drawable:ic_add", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_add.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_640_781_097)
internal val Res.drawable.ic_add_location_alt: DrawableResource by lazy {
      DrawableResource("drawable:ic_add_location_alt", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_add_location_alt.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_396_956_007)
internal val Res.drawable.ic_arrow_back: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_arrow_back.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_621_712_224)
internal val Res.drawable.ic_bakery_dining: DrawableResource by lazy {
      DrawableResource("drawable:ic_bakery_dining", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_bakery_dining.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_572_315_943)
internal val Res.drawable.ic_bakery_dining_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_bakery_dining_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_bakery_dining_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(312_348_880)
internal val Res.drawable.ic_bedtime: DrawableResource by lazy {
      DrawableResource("drawable:ic_bedtime", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_bedtime.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-842_661_218)
internal val Res.drawable.ic_block: DrawableResource by lazy {
      DrawableResource("drawable:ic_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_block.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(433_555_034)
internal val Res.drawable.ic_call: DrawableResource by lazy {
      DrawableResource("drawable:ic_call", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_call.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_074_781_641)
internal val Res.drawable.ic_call_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_call_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_call_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_693_675_389)
internal val Res.drawable.ic_cancel_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_cancel_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_cancel_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-132_713_219)
internal val Res.drawable.ic_check: DrawableResource by lazy {
      DrawableResource("drawable:ic_check", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_check.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_065_199_566)
internal val Res.drawable.ic_check_circle_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_check_circle_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_check_circle_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_806_203_359)
internal val Res.drawable.ic_chevron_left: DrawableResource by lazy {
      DrawableResource("drawable:ic_chevron_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_chevron_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_021_387_019)
internal val Res.drawable.ic_chevron_right: DrawableResource by lazy {
      DrawableResource("drawable:ic_chevron_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_chevron_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(412_276_578)
internal val Res.drawable.ic_circle: DrawableResource by lazy {
      DrawableResource("drawable:ic_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_circle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-597_342_716)
internal val Res.drawable.ic_close: DrawableResource by lazy {
      DrawableResource("drawable:ic_close", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_close.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(477_418_953)
internal val Res.drawable.ic_directions_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_directions_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_directions_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_251_433_609)
internal val Res.drawable.ic_eco: DrawableResource by lazy {
      DrawableResource("drawable:ic_eco", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_eco.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_078_398_177)
internal val Res.drawable.ic_eco_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_eco_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_eco_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_051_176_297)
internal val Res.drawable.ic_error: DrawableResource by lazy {
      DrawableResource("drawable:ic_error", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_error.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(930_244_229)
internal val Res.drawable.ic_expand_less: DrawableResource by lazy {
      DrawableResource("drawable:ic_expand_less", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_expand_less.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_092_474_400)
internal val Res.drawable.ic_expand_more: DrawableResource by lazy {
      DrawableResource("drawable:ic_expand_more", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_expand_more.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_312_003_147)
internal val Res.drawable.ic_fastfood: DrawableResource by lazy {
      DrawableResource("drawable:ic_fastfood", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_fastfood.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(406_334_384)
internal val Res.drawable.ic_fastfood_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_fastfood_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_fastfood_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(833_158_576)
internal val Res.drawable.ic_favorite: DrawableResource by lazy {
      DrawableResource("drawable:ic_favorite", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_favorite.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-295_323_456)
internal val Res.drawable.ic_favorite_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_favorite_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_favorite_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(712_277_756)
internal val Res.drawable.ic_help_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_help_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_help_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_380_189_011)
internal val Res.drawable.ic_icecream: DrawableResource by lazy {
      DrawableResource("drawable:ic_icecream", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_icecream.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_946_280_624)
internal val Res.drawable.ic_icecream_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_icecream_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_icecream_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-4_243_802)
internal val Res.drawable.ic_info: DrawableResource by lazy {
      DrawableResource("drawable:ic_info", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_info.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(607_905_427)
internal val Res.drawable.ic_ios_share: DrawableResource by lazy {
      DrawableResource("drawable:ic_ios_share", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_ios_share.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-903_470_049)
internal val Res.drawable.ic_language: DrawableResource by lazy {
      DrawableResource("drawable:ic_language", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_language.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_089_573_738)
internal val Res.drawable.ic_local_cafe: DrawableResource by lazy {
      DrawableResource("drawable:ic_local_cafe", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_local_cafe.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_109_340_146)
internal val Res.drawable.ic_local_cafe_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_local_cafe_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_local_cafe_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(470_472_343)
internal val Res.drawable.ic_local_shipping: DrawableResource by lazy {
      DrawableResource("drawable:ic_local_shipping", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_local_shipping.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_423_903_657)
internal val Res.drawable.ic_local_shipping_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_local_shipping_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_local_shipping_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_651_937_627)
internal val Res.drawable.ic_location_on: DrawableResource by lazy {
      DrawableResource("drawable:ic_location_on", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_location_on.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-363_779_959)
internal val Res.drawable.ic_lunch_dining: DrawableResource by lazy {
      DrawableResource("drawable:ic_lunch_dining", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_lunch_dining.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_295_757_957)
internal val Res.drawable.ic_lunch_dining_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_lunch_dining_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_lunch_dining_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_018_281_401)
internal val Res.drawable.ic_mail: DrawableResource by lazy {
      DrawableResource("drawable:ic_mail", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_mail.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_275_044_377)
internal val Res.drawable.ic_map: DrawableResource by lazy {
      DrawableResource("drawable:ic_map", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_map.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-404_879_466)
internal val Res.drawable.ic_map_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_map_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_map_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-124_481_831)
internal val Res.drawable.ic_my_location: DrawableResource by lazy {
      DrawableResource("drawable:ic_my_location", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_my_location.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_092_646_714)
internal val Res.drawable.ic_near_me_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_near_me_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_near_me_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-423_998_475)
internal val Res.drawable.ic_north_west: DrawableResource by lazy {
      DrawableResource("drawable:ic_north_west", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_north_west.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_101_073_645)
internal val Res.drawable.ic_notifications: DrawableResource by lazy {
      DrawableResource("drawable:ic_notifications", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_notifications.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_691_343_594)
internal val Res.drawable.ic_person: DrawableResource by lazy {
      DrawableResource("drawable:ic_person", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_person.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(870_150_585)
internal val Res.drawable.ic_person_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_person_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_person_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_854_713_098)
internal val Res.drawable.ic_radar: DrawableResource by lazy {
      DrawableResource("drawable:ic_radar", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_radar.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_291_546_634)
internal val Res.drawable.ic_remove: DrawableResource by lazy {
      DrawableResource("drawable:ic_remove", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_remove.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-153_102_689)
internal val Res.drawable.ic_restaurant: DrawableResource by lazy {
      DrawableResource("drawable:ic_restaurant", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_restaurant.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-153_102_689)
internal val Res.drawable.ic_restaurant_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_restaurant_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_restaurant_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_400_006_758)
internal val Res.drawable.ic_schedule: DrawableResource by lazy {
      DrawableResource("drawable:ic_schedule", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_schedule.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_475_414_623)
internal val Res.drawable.ic_search: DrawableResource by lazy {
      DrawableResource("drawable:ic_search", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_search.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(593_330_504)
internal val Res.drawable.ic_settings: DrawableResource by lazy {
      DrawableResource("drawable:ic_settings", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_settings.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_052_457_258)
internal val Res.drawable.ic_share: DrawableResource by lazy {
      DrawableResource("drawable:ic_share", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_share.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_484_568_844)
internal val Res.drawable.ic_star: DrawableResource by lazy {
      DrawableResource("drawable:ic_star", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_star.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(636_718_925)
internal val Res.drawable.ic_star_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_star_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_star_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-873_219_160)
internal val Res.drawable.ic_storefront: DrawableResource by lazy {
      DrawableResource("drawable:ic_storefront", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_storefront.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(82_664_043)
internal val Res.drawable.ic_storefront_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_storefront_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_storefront_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(142_770_540)
internal val Res.drawable.ic_trending_up: DrawableResource by lazy {
      DrawableResource("drawable:ic_trending_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_trending_up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-884_129_942)
internal val Res.drawable.ic_tune: DrawableResource by lazy {
      DrawableResource("drawable:ic_tune", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_tune.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(637_142_316)
internal val Res.drawable.ic_unfold_more: DrawableResource by lazy {
      DrawableResource("drawable:ic_unfold_more", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_unfold_more.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_866_482_154)
internal val Res.drawable.ic_water_drop_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_water_drop_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_water_drop_filled.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_add", Res.drawable.ic_add)
  map.put("ic_add_location_alt", Res.drawable.ic_add_location_alt)
  map.put("ic_arrow_back", Res.drawable.ic_arrow_back)
  map.put("ic_bakery_dining", Res.drawable.ic_bakery_dining)
  map.put("ic_bakery_dining_filled", Res.drawable.ic_bakery_dining_filled)
  map.put("ic_bedtime", Res.drawable.ic_bedtime)
  map.put("ic_block", Res.drawable.ic_block)
  map.put("ic_call", Res.drawable.ic_call)
  map.put("ic_call_filled", Res.drawable.ic_call_filled)
  map.put("ic_cancel_filled", Res.drawable.ic_cancel_filled)
  map.put("ic_check", Res.drawable.ic_check)
  map.put("ic_check_circle_filled", Res.drawable.ic_check_circle_filled)
  map.put("ic_chevron_left", Res.drawable.ic_chevron_left)
  map.put("ic_chevron_right", Res.drawable.ic_chevron_right)
  map.put("ic_circle", Res.drawable.ic_circle)
  map.put("ic_close", Res.drawable.ic_close)
  map.put("ic_directions_filled", Res.drawable.ic_directions_filled)
  map.put("ic_eco", Res.drawable.ic_eco)
  map.put("ic_eco_filled", Res.drawable.ic_eco_filled)
  map.put("ic_error", Res.drawable.ic_error)
  map.put("ic_expand_less", Res.drawable.ic_expand_less)
  map.put("ic_expand_more", Res.drawable.ic_expand_more)
  map.put("ic_fastfood", Res.drawable.ic_fastfood)
  map.put("ic_fastfood_filled", Res.drawable.ic_fastfood_filled)
  map.put("ic_favorite", Res.drawable.ic_favorite)
  map.put("ic_favorite_filled", Res.drawable.ic_favorite_filled)
  map.put("ic_help_filled", Res.drawable.ic_help_filled)
  map.put("ic_icecream", Res.drawable.ic_icecream)
  map.put("ic_icecream_filled", Res.drawable.ic_icecream_filled)
  map.put("ic_info", Res.drawable.ic_info)
  map.put("ic_ios_share", Res.drawable.ic_ios_share)
  map.put("ic_language", Res.drawable.ic_language)
  map.put("ic_local_cafe", Res.drawable.ic_local_cafe)
  map.put("ic_local_cafe_filled", Res.drawable.ic_local_cafe_filled)
  map.put("ic_local_shipping", Res.drawable.ic_local_shipping)
  map.put("ic_local_shipping_filled", Res.drawable.ic_local_shipping_filled)
  map.put("ic_location_on", Res.drawable.ic_location_on)
  map.put("ic_lunch_dining", Res.drawable.ic_lunch_dining)
  map.put("ic_lunch_dining_filled", Res.drawable.ic_lunch_dining_filled)
  map.put("ic_mail", Res.drawable.ic_mail)
  map.put("ic_map", Res.drawable.ic_map)
  map.put("ic_map_filled", Res.drawable.ic_map_filled)
  map.put("ic_my_location", Res.drawable.ic_my_location)
  map.put("ic_near_me_filled", Res.drawable.ic_near_me_filled)
  map.put("ic_north_west", Res.drawable.ic_north_west)
  map.put("ic_notifications", Res.drawable.ic_notifications)
  map.put("ic_person", Res.drawable.ic_person)
  map.put("ic_person_filled", Res.drawable.ic_person_filled)
  map.put("ic_radar", Res.drawable.ic_radar)
  map.put("ic_remove", Res.drawable.ic_remove)
  map.put("ic_restaurant", Res.drawable.ic_restaurant)
  map.put("ic_restaurant_filled", Res.drawable.ic_restaurant_filled)
  map.put("ic_schedule", Res.drawable.ic_schedule)
  map.put("ic_search", Res.drawable.ic_search)
  map.put("ic_settings", Res.drawable.ic_settings)
  map.put("ic_share", Res.drawable.ic_share)
  map.put("ic_star", Res.drawable.ic_star)
  map.put("ic_star_filled", Res.drawable.ic_star_filled)
  map.put("ic_storefront", Res.drawable.ic_storefront)
  map.put("ic_storefront_filled", Res.drawable.ic_storefront_filled)
  map.put("ic_trending_up", Res.drawable.ic_trending_up)
  map.put("ic_tune", Res.drawable.ic_tune)
  map.put("ic_unfold_more", Res.drawable.ic_unfold_more)
  map.put("ic_water_drop_filled", Res.drawable.ic_water_drop_filled)
}
